<ion-content class="edit-user">
  <ng-container>
    <app-header [title]="'Edit User'"></app-header>
    <div class="loading-container" style="padding-top:10%" *ngIf="!loaded">
      <ion-spinner></ion-spinner>
    </div>
    <ion-grid>
      <ion-row class="user-form">
        <ion-grid>
          <ion-row>
            <ion-col>
              <ion-label>Login</ion-label>
              <div>
                <ion-input type="text" [(ngModel)]="login" placeholder="Enter login"
                  class="ion-text-left color-light"></ion-input>
              </div>
            </ion-col>
            <ion-col>
              <ion-label>New Password</ion-label>
              <div>
                <ion-input type="text" [(ngModel)]="password" placeholder="Enter new password (not required)"
                  class="ion-text-left color-light"></ion-input>
              </div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-label>First Name</ion-label>
              <div>
                <ion-input type="text" [(ngModel)]="firstName" placeholder="Enter first name"
                  class="ion-text-left color-light"></ion-input>
              </div>
            </ion-col>
            <ion-col>
              <ion-label>Last Name</ion-label>
              <div>
                <ion-input type="text" [(ngModel)]="lastName" placeholder="Enter last name"
                  class="ion-text-left color-light"></ion-input>
              </div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-label><span>User Status:</span></ion-label>
              <ion-select interface="popover" placeholder="Select Active or Disabled" [(ngModel)]="userStatus">
                <ion-select-option value="0">Active</ion-select-option>
                <ion-select-option value="1">Disabled</ion-select-option>
              </ion-select>
            </ion-col>
            <ion-col>
              <ion-label><span>User Type</span></ion-label>
              <ion-select [(ngModel)]="type" interface="popover" placeholder="Select User Type" value="User"
                (ionChange)="selectUserType($event)">
                <ion-select-option value="User">User</ion-select-option>
                <ion-select-option value="Admin">Admin</ion-select-option>
                <ion-select-option value="Internal User">Internal User</ion-select-option>
                <ion-select-option value="Route Driver">Route Driver</ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row>
          <ion-grid class="table-grid" *ngIf="isCostCenter">
            <ion-label class="header-inline">
              <span>User Customer Assignment</span>
              <ion-button size="small" fill="clear" class="view-link" (click)="manageUser()">
                Manage
              </ion-button>
            </ion-label>

            <ion-row class="table-header" *ngIf="departmentList.length>0">
              <ion-col size="6">
                Cust
              </ion-col>
              <ion-col size="6">
                <span> Cost Center</span>
              </ion-col>
            </ion-row>

            <ion-row class="table-row" *ngIf="departmentList.length>0">
              <ion-col size="6">
                ({{results?.webLogin?.customerCode}}) {{customerName}}
              </ion-col>
              <ion-col size="6">
                <div class="cost-center-item" *ngFor="let cc of departmentList | slice:0:5">
                  ({{ cc?.costCenterCode }}) {{ cc?.costCenterName }}
                </div>

                <div class="more-count" *ngIf="departmentList?.length > 5">

                  <ion-button size="small" fill="clear" class="view-link" (click)="manageUser()">
                    {{ departmentList.length }} Total:(View)
                  </ion-button>
                </div>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="departmentList.length==0">
              <ion-label style="color:red;padding-left:20px"> Warning: No Customer Assignment for this User</ion-label>
            </ion-row>
          </ion-grid>
          <ion-grid class="table-grid" *ngIf="!isCostCenter">
            <ion-label class="header-inline">
              <span>User Customer Assignment</span>
              <ion-button size="small" fill="clear" class="view-link" (click)="manageUser()">
                Manage
              </ion-button>
            </ion-label>

            <ion-row class="table-header">
              <ion-col size="6">
                Cust
              </ion-col>
              <ion-col size="6">
                <span>Dept</span>
              </ion-col>
            </ion-row>

            <ion-row class="table-row" *ngFor="let cust of groupedCustomers">

              <ion-col size="6">
                ({{ cust.customerCode }}) {{ cust.customerName }}
              </ion-col>

              <ion-col size="6">
                <div class="cost-center-item" *ngFor="let dept of cust.departments">
                  <span *ngIf="dept?.departmentCode"> ({{ dept.departmentCode }}) {{ dept.description }}</span>
                </div>
              </ion-col>

            </ion-row>
          </ion-grid>

          <ion-row class="checkbox-row">
            <ion-col>
              <ion-item no-lines>
                <ion-checkbox [(ngModel)]="placeOrders" slot="start"></ion-checkbox>
                <ion-label>Place Orders</ion-label>
              </ion-item>
            </ion-col>
            <ion-col>
              <ion-item no-lines>
                <ion-checkbox [(ngModel)]="cancelEmp" slot="start"></ion-checkbox>
                <ion-label>Cancel Employee</ion-label>
              </ion-item>
            </ion-col>
            <ion-col>
              <ion-item no-lines>
                <ion-checkbox [(ngModel)]="viewInvoices" slot="start"></ion-checkbox>
                <ion-label>View Invoices</ion-label>
              </ion-item>
            </ion-col>
            <ion-col>
              <ion-item no-lines>
                <ion-checkbox [(ngModel)]="viewTransfers" slot="start"></ion-checkbox>
                <ion-label>View Employee Transfers</ion-label>
              </ion-item>
            </ion-col>

          </ion-row>


          <ion-grid>
            <ion-row>
              <ion-col size="12" class="header-row">
                <div class="title"> Select the reports for user access</div>
              </ion-col>
            </ion-row>

            <ion-row class="table-header">
              <ion-col size="1"></ion-col>
              <ion-col><strong>Name</strong></ion-col>
              <ion-col><strong>Category</strong></ion-col>
            </ion-row>

            <ion-row *ngFor="let report of reports" class="table-row">
              <ion-col size="1" class="checkbox-col">
                <ion-checkbox [(ngModel)]="report.hasAccess"></ion-checkbox>
              </ion-col>

              <ion-col>
                <ion-label>{{ report.shortName }}</ion-label>
              </ion-col>

              <ion-col>
                <ion-label>{{ report.category }}</ion-label>
              </ion-col>
            </ion-row>

          </ion-grid>


          <ion-row>
            <ion-col></ion-col>
            <ion-col size="auto">
              <ion-button color="gallaghergreen" (click)="submit()"
                class="btn-box-shadow btn-margin"><span>Submit</span></ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-row>
    </ion-grid>
  </ng-container>
</ion-content>